"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ContactFormButtonContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: -40px;\n    width: 260px;\n"], ["\n    margin-left: -40px;\n    width: 260px;\n"])));
exports.ContactPageButtonRow = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 14px 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n"], ["\n    margin: 14px 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n"])));
var templateObject_1, templateObject_2;